import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import axios from "axios";
import {
    Table, Button, Modal, ModalHeader, ModalBody, ModalFooter, Container, Input, FormGroup,
    Label
} from "reactstrap";
import { Link } from "react-router-dom";
/*import { useUser } from '../components/Context/UserContext';*/
import { useUser } from './Context/UserContext';
import profileImg from "../assets/logo.png";
import "../styles/Reports.css";
import VendorInfoTabs from "./VendorInfoTabs";
import DashboardLayout from "../../src/components/DashboardLayout";
const ViewAllVendorReports = () => {
    const [showReminderToast, setShowReminderToast] = useState(false);
    const [reminderVendor, setReminderVendor] = useState(null);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [vendorInfo, setVendorInfo] = useState(null);
    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
    const { user } = useUser();
    const [errors, setErrors] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [vendorDetails, setVendorDetails] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [approvedStatusList, setApprovedStatusList] = useState([]);
    const [vendorSortBy, setVendorSortBy] = useState(null);
    const [vendorSortOrder, setVendorSortOrder] = useState("asc");
    const [vendorApprovalSortOrder, setVendorApprovalSortOrder] = useState("asc");
    const [vendorApprovalSortBy, setVendorApprovalSortBy] = useState(null);
    const [departmentHeads, setDepartmentHeads] = useState([]);
    const [deptId, setDeptId] = useState(""); // Selected head
    const [searchTerm, setSearchTerm] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [activeTab, setActiveTab] = useState("history"); // which tab is active
    const [users, setUsers] = useState([]); // approval history for selected vendor
    const [approvalHistory, setApprovalHistory] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    //const [vendors, setVendors] = useState([]);
    const [subTab, setSubTab] = useState("details");
    const { user: loggedInUser } = useUser();
    const [approverId, setApproverId] = useState(null);
    const [showFilters, setShowFilters] = useState(false);
    const userRole = user?.roles?.[0]?.role?.trim().toLowerCase() || "";
    const isFinanceTeam = userRole.includes("finance");
    // ---- Vendor visibility: Finance/CFO/Super Admin see all, others see only their own ----
    const seeAllVendors = (user?.roles || []).some(r => {
        const name = (r?.role || "").trim().toLowerCase();
        return name.includes("finance") || name.includes("cfo") || name.includes("super admin");
    });
    const userEmpId = seeAllVendors ? "" : String(user?.empId || "");

    const REPORT_URL = "/api/viewallvendorreports/GetVendorsReports";

    const fetchReports = async (baseParams = {}) => {
        if (!userEmpId) {
            const res = await axios.get(REPORT_URL, { params: baseParams });
            return res.data;
        }
        const [asDeptHead, asVerifier] = await Promise.all([
            axios.get(REPORT_URL, { params: { ...baseParams, deptId: userEmpId, verifierId: "" } }),
            axios.get(REPORT_URL, { params: { ...baseParams, verifierId: userEmpId, deptId: "" } })
        ]);
        const map = new Map();
        [...asDeptHead.data, ...asVerifier.data].forEach(v => {
            const key = v.id ?? v.ID;
            if (!map.has(key)) map.set(key, v);
        });
        return Array.from(map.values());
    };

    useEffect(() => {
        const id = loggedInUser?.empId || sessionStorage.getItem("userId");
        if (id) {
            setApproverId(id); // ensure number
            console.log("✅ Approver ID set:", id);
        } else {
            console.log("⏳ Waiting for user info to load...");
        }
    }, [loggedInUser]);
    useEffect(() => {
        const dark = localStorage.getItem("darkMode") === "true";
        document.body.classList.toggle("dark-mode", dark);
    }, []);
    const [formData, setFormData] = useState({
        natureOfSupply: "",
        pan: "",
        msme: "",
        approvedStatus: "",
        emailId: "",
        departmentHead: "",
        fromDate: "",
        toDate: ""
    });
    const handleFormChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [id]: value
        }));
    };
    const handleVendorFieldChange = (field, value) => {
        setSelectedVendor(prev => ({
            ...prev,
            [field]: value
        }));
    };
    const handleVendorInputChange = (e, field) => {
        setSelectedVendor(prev => ({ ...prev, [field]: e.target.value }));
    };
    const filteredVendors = vendorDetails.filter((vendor) =>
        vendor.nameOfCompany
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase())
    );
    useEffect(() => {
        const fetchDepartmentHeads = async () => {
            try {
                const res = await axios.get("/department/department-heads");
                // Make sure your backend endpoint returns all rows: EMPID + USERNAME
                console.log("Department heads fetched:", res.data);
                setDepartmentHeads(res.data);
            } catch (err) {
                console.error("Failed to load department heads", err);
            }
        };
        fetchDepartmentHeads();
    }, []);
    const getNatureOfSupplyLabel = (value) => {
        switch (Number(value)) {
            case 1:
                return "Goods";
            case 2:
                return "Services";
            default:
                return "N/A";
        }
    };
    const handleSearch = async (e) => {
        e.preventDefault();
        const params = {
            natureOfSupply: Number(formData.natureOfSupply) || 0,
            msmeId: Number(formData.msme) || 0,
            approvedStatus: Number(formData.approvedStatus) || 0,
            panNumber: formData.pan?.trim() || "",
            emailId: formData.emailId?.trim() || "",
            departmentHead: "",
            verifierId: "",
            deptId: deptId || "",
            search: searchTerm?.trim() || ""
        };
        try {
            const data = await fetchReports(params);
            setVendorDetails(data);
            setCurrentPage(1);
        } catch (error) {
            console.error("Error fetching vendor data:", error);
            setVendorDetails([]);
            setCurrentPage(1);
        }
    };
    const handleVendorSort = (column) => {
        const sorted = [...vendorDetails].sort((a, b) => {
            let valueA = a[column]?.toLowerCase() || "";
            let valueB = b[column]?.toLowerCase() || "";
            if (vendorSortOrder === "asc") {
                return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
            } else {
                return valueA < valueB ? 1 : valueA > valueB ? -1 : 0;
            }
        });
        setVendorDetails(sorted);
        setVendorSortOrder(vendorSortOrder === "asc" ? "desc" : "asc");
        setVendorSortBy(column);
    };
    const handleVendorApprovalSort = () => {
        const sorted = [...vendorDetails].sort((a, b) => {
            let valueA = a.approvalStatus?.toLowerCase() || "";
            let valueB = b.approvalStatus?.toLowerCase() || "";
            if (vendorApprovalSortOrder === "asc") {
                return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
            } else {
                return valueA < valueB ? 1 : valueA > valueB ? -1 : 0;
            }
        });
        setVendorDetails(sorted);
        setVendorApprovalSortOrder(
            vendorApprovalSortOrder === "asc" ? "desc" : "asc"
        );
        setVendorApprovalSortBy("approvalStatus");
    };
    const handleReviewClick = (index) => {
        const vendor = paginatedVendors[index];
        const actualUserId = vendor.USERID ?? vendor.userId ?? vendor.userid ?? 0;
        if (!actualUserId || actualUserId === 0) {
            console.warn("❌ User ID missing, cannot fetch approval history for vendor:", vendor);
            setUsers([]);
        }
        console.log("Clicked vendor:", vendor);
        setSelectedVendor({
            ...vendor,
            userId: actualUserId || vendor.userId || vendor.UserId || vendor.userid || vendor.id || vendor.userid || null,
            index
        });
        setShowModal(true);
        setIsEditing(false);
        setActiveTab("history");
    };
    useEffect(() => {
        const vendorId = selectedVendor?.id ?? selectedVendor?.ID;
        const userId = selectedVendor?.userid ?? selectedVendor?.userId;

        if (!vendorId && !userId) {
            setApprovalHistory([]);
            return;
        }

        let cancelled = false;

        const load = async () => {
            for (const id of [vendorId, userId]) {
                if (!id) continue;
                try {
                    const res = await axios.get(`/api/approvalstatus/status/${id}`);
                    if (res.data?.length) {
                        if (!cancelled) setApprovalHistory(res.data);
                        return;
                    }
                } catch (err) {
                    // 404 = no rows under this ID, try the next one
                }
            }
            if (!cancelled) setApprovalHistory([]);
        };

        load();
        return () => { cancelled = true; };
    }, [selectedVendor?.id, selectedVendor?.ID, selectedVendor?.userid, selectedVendor?.userId]);
    useEffect(() => {
        if (!user?.empId) return;
        const load = async () => {
            try {
                const data = await fetchReports();
                setVendorDetails(data);
                setCurrentPage(1);
            } catch (error) {
                console.error("Error fetching initial vendor data:", error);
                setVendorDetails([]);
                setCurrentPage(1);
            }
        };
        load();
    }, [user?.empId]);
    useEffect(() => {
        const fetchApprovedStatuses = async () => {
            try {
                const response = await axios.get("/api/viewallvendorreports/GetApprovedStatusList");
                console.log("Approved statuses fetched:", response.data);
                setApprovedStatusList(response.data);
            } catch (error) {
                console.error("Error fetching approved status list:", error);
            }
        };
        fetchApprovedStatuses();
    }, []);
    const handleClear = async () => {
        setFormData({
            natureOfSupply: "",
            pan: "",
            msme: "",
            approvedStatus: "",
            emailId: "",
            departmentHeads: "",
            deptId: "",
            fromDate: "",
            toDate: ""
        });
        setDeptId("");
        setErrors({});
        try {
            const data = await fetchReports();
            setVendorDetails(data);
            setCurrentPage(1);
        } catch (error) {
            console.error("Error reloading vendor data:", error);
            setVendorDetails([]);
            setCurrentPage(1);
        }
    };
    const handleRowsChange = (e) => {
        const value = e.target.value;
        if (!value) {
            setRowsPerPage(10);
            setCurrentPage(1);
            return;
        }
        const parsed = parseInt(value);
        if (!isNaN(parsed)) {
            setRowsPerPage(parsed);
            setCurrentPage(1);
        }
    };
    const itemsPerPage = 10;
    const paginatedVendors = filteredVendors.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );
    useEffect(() => {
        setTotalPages(Math.ceil(filteredVendors.length / rowsPerPage));
    }, [filteredVendors, rowsPerPage]);
    const handlePageChange = (type) => {
        if (type === "first") setCurrentPage(1);
        if (type === "prev" && currentPage > 1) setCurrentPage(currentPage - 1);
        if (type === "next" && currentPage < totalPages) setCurrentPage(currentPage + 1);
        if (type === "last") setCurrentPage(totalPages);
    };
    const handleExport = async () => {
        try {
            let rows;
            if (seeAllVendors) {
                const response = await axios.get("/api/viewallvendorreports/GetAllVendorsReportsRaw");
                rows = response.data;
            } else {
                rows = filteredVendors; // only their own vendors
            }
            if (!rows || rows.length === 0) {
                alert("No vendor data to export.");
                return;
            }
            const dataToExport = rows.map(vendor => {
                const formatted = {};
                for (const key in vendor) {
                    let value = vendor[key];
                    if (key.toLowerCase() === "msmeno") value = value ? "Yes" : "No";
                    if (!value) value = "N/A";
                    const label = key.replace(/([a-z])([A-Z])/g, "$1 $2").toUpperCase();
                    formatted[label] = value;
                }
                return formatted;
            });
            const worksheet = XLSX.utils.json_to_sheet(dataToExport);
            worksheet["!cols"] = Object.keys(dataToExport[0]).map(key => ({
                wch: Math.max(
                    key.length,
                    ...dataToExport.map(row => row[key]?.toString().length || 0)
                ) + 2
            }));
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Vendor Report");
            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
            const blob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            saveAs(blob, "Vendor_Report.xlsx");
        } catch (error) {
            console.error("Export failed:", error);
            alert("Failed to export vendor data. Check console for details.");
        }
    };

    const handleReminder = async (vendor) => {
        try {
            const recordId = vendor.id || vendor.ID;
            if (!recordId) {
                console.error("No vendor ID found:", vendor);
                return;
            }
            const res = await axios.post("/api/approvalstatus/send-vendor-reminder", {
                id: recordId
            });
            console.log("Vendor reminder sent successfully");
            setReminderVendor({ ...vendor, testEmail: res.data.testEmail });
            setShowReminderToast(true);
            setTimeout(() => setShowReminderToast(false), 5000);
        } catch (err) {
            console.error("Failed to send vendor reminder:", err.response?.data || err.message);
            setReminderVendor({ ...vendor, testEmail: "N/A — " + (err.response?.data?.message || err.message) });
            setShowReminderToast(true);
            setTimeout(() => setShowReminderToast(false), 5000);
        }
    };

    return (
        <DashboardLayout>
            <div className="view-vendors-container">
                <div className="page-header">
                    <h2 className="page-title">
                        <span className="title-icon">🏢</span>
                        Vendor Overview
                    </h2>
                    <div className="title-underline"></div>
                </div>
                <div >
                    <div className="content-area">
                        <div className="filter-header">
                            <button
                                type="button"
                                className={`filter-toggle-btn ${showFilters ? "active" : ""}`}
                                onClick={() => setShowFilters(!showFilters)}
                            >
                                <span className="filter-icon">🔍</span>
                                <span className="filter-text">Filters</span>
                                <span className="filter-arrow">{showFilters ? "▲" : "▼"}</span>
                            </button>
                        </div>
                        {showFilters && (
                            <div className="filter-container">
                                <div className="filter-grid">
                                    <div className="filter-item">
                                        <label>Nature</label>
                                        <select
                                            id="natureOfSupply"
                                            value={formData.natureOfSupply}
                                            onChange={handleFormChange}
                                        >
                                            <option value="0">Select</option>
                                            <option value="1">Goods</option>
                                            <option value="2">Services</option>
                                        </select>
                                    </div>
                                    <div className="filter-item">
                                        <label>MSME</label>
                                        <select
                                            id="msme"
                                            value={formData.msme}
                                            onChange={handleFormChange}
                                        >
                                            <option value="0">Select</option>
                                            <option value="1">Yes</option>
                                            <option value="2">No</option>
                                        </select>
                                    </div>
                                    <div className="filter-item">
                                        <label>PAN</label>
                                        <input
                                            type="text"
                                            id="pan"
                                            value={formData.pan}
                                            onChange={handleFormChange}
                                        />
                                    </div>
                                    <div className="filter-item">
                                        <label>Status</label>
                                        <select
                                            id="approvedStatus"
                                            value={formData.approvedStatus}
                                            onChange={handleFormChange}
                                        >
                                            <option value="">Select</option>
                                            {approvedStatusList.map((status) => (
                                                <option key={status.id} value={status.id}>
                                                    {status.title}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="filter-item">
                                        <label>Email</label>
                                        <input
                                            type="email"
                                            id="emailId"
                                            value={formData.emailId}
                                            onChange={handleFormChange}
                                        />
                                    </div>
                                    <div className="filter-item">
                                        <label>Dept Head</label>
                                        <select
                                            value={deptId}
                                            onChange={(e) => setDeptId(e.target.value)}
                                        >
                                            <option value="">Select</option>
                                            {departmentHeads.map((head, index) => (
                                                <option key={`${head.empId}-${index}`} value={head.empId}>
                                                    {head.userName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="filter-item">
                                        <label>From</label>
                                        <input
                                            type="date"
                                            id="fromDate"
                                            value={formData.fromDate}
                                            onChange={handleFormChange}
                                        />
                                    </div>
                                    <div className="filter-item">
                                        <label>To</label>
                                        <input
                                            type="date"
                                            id="toDate"
                                            value={formData.toDate}
                                            onChange={handleFormChange}
                                        />
                                    </div>
                                </div>
                                {/* Buttons */}
                                <div className="filter-actions">
                                    <button className="btn primary" onClick={handleSearch}>Search</button>
                                    <button className="btn success" onClick={handleExport}>Export</button>
                                    <button className="btn secondary" onClick={handleClear}>Clear</button>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="table-controls">
                        <div style={{ flex: 1, textAlign: "left" }}>
                            <div style={{ position: "relative", width: "280px" }}>
                                {/* Search Icon */}
                                <span style={{
                                    position: "absolute",
                                    left: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    color: "#6c757d",
                                    fontSize: "14px"
                                }}>
                                    🔍
                                </span>
                                <Input
                                    type="text"
                                    placeholder="Search by Company Name..."
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                        setCurrentPage(1);
                                    }}
                                    style={{
                                        width: "100%",
                                        height: "38px",
                                        borderRadius: "10px",
                                        fontSize: "14px",
                                        paddingLeft: "32px",
                                        border: "1px solid #ced4da",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                                        transition: "0.3s",
                                        backgroundColor: "#f8fbff"
                                    }}
                                    onFocus={(e) => e.target.style.boxShadow = "0 0 6px rgba(10,66,117,0.4)"}
                                    onBlur={(e) => e.target.style.boxShadow = "0 2px 6px rgba(0,0,0,0.08)"}
                                />
                            </div>
                        </div>
                        <div className="pagination-modern">
                            <button
                                onClick={() => handlePageChange("first")}
                                disabled={currentPage === 1}
                            >
                                ⏮
                            </button>
                            <button
                                onClick={() => handlePageChange("prev")}
                                disabled={currentPage === 1}
                            >
                                ◀
                            </button>
                            <span className="page-info">
                                Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
                            </span>
                            <button
                                onClick={() => handlePageChange("next")}
                                disabled={currentPage === totalPages}
                            >
                                ▶
                            </button>
                            <button
                                onClick={() => handlePageChange("last")}
                                disabled={currentPage === totalPages}
                            >
                                ⏭
                            </button>
                        </div>
                    </div>
                    <div className="content-area">
                        <div className="table-responsive">
                            <Table className="invoices-table">
                                <thead>
                                    <tr>
                                        <th
                                            onClick={() => handleVendorSort("nameOfCompany")}
                                            className="sortable header-cell wide-col"
                                        >
                                            COMPANY NAME
                                            <span className="sort-icon">
                                                {vendorSortBy === "nameOfCompany"
                                                    ? vendorSortOrder === "asc" ? "▲" : "▼"
                                                    : "⇅"}
                                            </span>
                                        </th>
                                        <th className="header-cell">CONTACT</th>
                                        <th>NATURE</th>
                                        <th>MSME</th>
                                        <th>PAN</th>
                                        <th>GST</th>
                                        <th>VERIFIER</th>
                                        <th>DEPT HEAD</th>
                                        <th onClick={handleVendorApprovalSort} className="sortable">
                                            APPROVAL STATUS
                                            <span className="sort-icon">
                                                {vendorApprovalSortBy === "approvalStatus"
                                                    ? vendorApprovalSortOrder === "asc" ? "▲" : "▼"
                                                    : "⇅"}
                                            </span>
                                        </th>
                                        <th colSpan={2} className="actions-header">ACTIONS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {vendorDetails && vendorDetails.length > 0 ? (
                                        paginatedVendors.map((vendor, index) => {
                                            const isPending = vendor.approvalStatus
                                                ?.trim()
                                                .toLowerCase()
                                                .includes("pending");

                                            return (
                                                <tr key={vendor.id || index}>
                                                    <td>{vendor.nameOfCompany || "N/A"}</td>
                                                    <td>{vendor.contactPersonName || "N/A"}</td>
                                                    <td>{getNatureOfSupplyLabel(vendor.natureOfSupply)}</td>
                                                    <td>{vendor.isMSME?.trim() ? "Yes" : "No"}</td>
                                                    <td>{vendor.pan || "N/A"}</td>
                                                    <td>{vendor.gst || "N/A"}</td>
                                                    <td>{vendor.verifierName || "N/A"}</td>
                                                    <td>{vendor.departmentHead || "N/A"}</td>
                                                    <td>
                                                        <span>
                                                            {vendor.approvalStatus || "N/A"}
                                                        </span>
                                                    </td>
                                                    {/* Actions */}
                                                    <td>
                                                        <button
                                                            className="action-btn view"
                                                            onClick={() => handleReviewClick(index)}
                                                        >
                                                            👁
                                                        </button>
                                                    </td>
                                                    <td>
                                                        {isPending && isFinanceTeam && (
                                                            <button className="action-btn reminder" onClick={() => handleReminder(vendor)}>
                                                                🔔
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="12" className="no-data">
                                                No records found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
            </div>
            <Modal isOpen={showModal} toggle={() => setShowModal(false)} centered className="modal-lg custom-modal">
                <ModalHeader toggle={() => setShowModal(false)}>Vendor Details</ModalHeader>
                {selectedVendor && (
                    <div className="vendor-summary-bar" style={{
                        padding: "10px 20px",
                        background: "#f4f8fc",
                        borderBottom: "1px solid #dde5ec",
                        display: "flex",
                        gap: "30px",
                        fontSize: "14px"
                    }}>
                        <div>
                            <strong>Vendor Name:</strong> {selectedVendor.nameOfCompany || "N/A"}
                        </div>
                        <div>
                            <strong>Vendor Code:</strong> {selectedVendor.vendorCode || "N/A"}
                        </div>
                    </div>
                )}
                <div className="tabs1">
                    <span className={activeTab === "history" ? "active-tab" : ""} onClick={() => setActiveTab("history")}>Vendor Approval History</span>
                    <span className={activeTab === "info" ? "active-tab" : ""} onClick={() => setActiveTab("info")}>Info</span>
                </div>
                <ModalBody>
                    {activeTab === "history" && approvalHistory && (
                        <Table bordered className="history-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Approval Status</th>
                                    <th>Approver Name</th>
                                    <th>Date</th>
                                    <th>Comments</th>
                                </tr>
                            </thead>
                            <tbody>
                                {approvalHistory.length > 0 ? approvalHistory.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.approvalStatus}</td>
                                        <td>{item.approvalName}</td>
                                        <td>{new Date(item.createDate).toLocaleString()}</td>
                                        <td>{item.comments || "N/A"}</td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="5" className="text-center">No history found</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    )}
                    {activeTab === "info" && selectedVendor && (
                        <VendorInfoTabs
                            selectedVendor={selectedVendor}   // ✅ pass the selected vendor
                            isEditing={isEditing}
                            setIsEditing={setIsEditing}
                            handleInputChange={handleVendorInputChange}
                            subTab={subTab}
                            setSubTab={setSubTab}
                            type="vendor"
                        />
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
            {showReminderToast && reminderVendor && (
                <div style={{
                    position: "fixed",
                    bottom: "30px",
                    right: "30px",
                    zIndex: 9999,
                    background: "#1f4e78",
                    color: "#fff",
                    borderRadius: "12px",
                    padding: "16px 20px",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
                    minWidth: "320px",
                    maxWidth: "400px",
                    animation: "slideIn 0.3s ease"
                }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <div style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                            <span style={{ fontSize: "24px" }}>🔔</span>
                            <div>
                                <div style={{ fontWeight: "700", fontSize: "15px", marginBottom: "8px" }}>
                                    Pending Approval Reminder
                                </div>
                                <div style={{ fontSize: "12px", opacity: 0.95, lineHeight: "1.8" }}>
                                    <div>🏢 Company: <strong>{reminderVendor.nameOfCompany || "N/A"}</strong></div>
                                    <div>👤 Contact: <strong>{reminderVendor.contactPersonName || "N/A"}</strong></div>
                                    <div>🔍 Verifier: <strong>{reminderVendor.verifierName || "N/A"}</strong></div>
                                    <div>👥 Dept Head: <strong>{reminderVendor.departmentHead || "N/A"}</strong></div>
                                    <div>📊 Current Status: <strong>{reminderVendor.approvalStatus || "N/A"}</strong></div>
                                    <div>📧 Sent To: <strong>{reminderVendor.testEmail || "N/A"}</strong></div>
                                    <div style={{
                                        marginTop: "8px",
                                        padding: "6px 10px",
                                        background: "rgba(255,255,255,0.15)",
                                        borderRadius: "6px",
                                        fontSize: "11px"
                                    }}>
                                        ⚠️ This vendor is pending approval. Please review and take action.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button
                            onClick={() => setShowReminderToast(false)}
                            style={{
                                background: "none", border: "none", color: "#fff",
                                cursor: "pointer", fontSize: "18px", padding: "0",
                                marginLeft: "10px", opacity: 0.8, lineHeight: 1
                            }}
                        >✕</button>
                    </div>
                    <div style={{ marginTop: "12px", background: "rgba(255,255,255,0.2)", borderRadius: "4px", height: "3px" }}>
                        <div style={{
                            height: "3px", background: "#fff", borderRadius: "4px",
                            animation: "shrink 5s linear forwards"
                        }} />
                    </div>
                </div>
            )}

            <style>{`
                @keyframes slideIn {
                    from { transform: translateX(120px); opacity: 0; }
                    to   { transform: translateX(0);     opacity: 1; }
                }
                @keyframes shrink {
                    from { width: 100%; }
                    to   { width: 0%;   }
                }
            `}</style>


        </DashboardLayout>
    );
}
export default ViewAllVendorReports;